import type { SVGProps } from 'react'
const SvgSyArrowLeft = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<g strokeLinejoin="round">
			<path
				d="M4.25 11.523a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h15a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75z"
				opacity={0.4}
			/>
			<path d="M10.3 5.5a.75.75 0 0 0-.529.219l-6.05 6.025a.75.75 0 0 0 0 1.063l6.05 6.023a.75.75 0 0 0 1.061-.002.75.75 0 0 0-.004-1.06l-5.515-5.493 5.515-5.494a.75.75 0 0 0 .004-1.06.75.75 0 0 0-.531-.221" />
		</g>
	</svg>
)
export default SvgSyArrowLeft
